import { apiClient } from "@/services/api"
import { defineStore } from "pinia"

export const useHourlyWageReportTagStore = defineStore("hourlywagereportTag", {
  state: () => ({
    tags: [],
  }),
  getters: {
    getTags: state => state.tags,
  },
  actions: {
    setTags(tags) {
      this.tags = tags
    },
    addTags(tags) {
      const stateTags = this.tags ? this.tags : []
      this.tags = stateTags.concat(tags)
    },
    createTag(tag) {
      return apiClient.post("/hourlywagereport/tags", tag).then(res => res)
    },
    loadTags() {
      return apiClient.get("/hourlywagereport/tags").then(res => {
        if (res.status === 200) {
          const data = res.data ? res.data : []
          this.setTags(data)
        }
        return res
      })
    },
    deleteTag(id) {
      return apiClient.delete(`/hourlywagereport/tags/${id}`, { headers: { tenant: true, authorization: true } })
    },
  },
})
